import { IRevenueSpendAllLang } from '../../../types/lang'
import { revenueSpendCrudModalLang } from './revenueSpendCrudModal'
import { revenueSpendPageLang } from './revenueSpendPage'
import { revenueSpendListTableLang } from './revenueSpendListTable'
import { revenueSpendByAccountListTableLang } from './revenueSpendByAccountListTable'
import { revenueSpendByAccountRevenueDetailsTableLang } from './revenueSpendByAccountRevenueDetailsTable'
import { revenueSpendByAccountOfferSpendDetailsTableLang } from './revenueSpendByAccountOfferSpendDetailsTable'
import { revenueSpendByAccountSpendDetailsTableLang } from './revenueSpendByAccountSpendDetailsTable'
import { revenueSpendByAccountPageLang } from './revenueSpendByAccountPage'
import { revenueSpendByTeamPageLang } from './revenueSpendByTeamPage'

export const revenueSpendAllLang: IRevenueSpendAllLang = {
	...revenueSpendPageLang,
	...revenueSpendCrudModalLang,
	...revenueSpendListTableLang,
	...revenueSpendByAccountListTableLang,
	...revenueSpendByAccountRevenueDetailsTableLang,
	...revenueSpendByAccountOfferSpendDetailsTableLang,
	...revenueSpendByAccountSpendDetailsTableLang,
	...revenueSpendByAccountPageLang,
	...revenueSpendByTeamPageLang
}